<template>
    <svg :width="size" :height="size" viewBox="0 0 16 16" :fill="color" xmlns="http://www.w3.org/2000/svg" class="paper-pin-outline">
    <path 
        d="M5.3639 10.6361L1.25 14.75M10.8716 10.5321L12.1378 9.26594C12.4244 8.9793 12.8132 8.81828 13.2185 8.81828C14.5802 8.81828 15.2621 7.17197 14.2993 6.20913L9.79086 1.70072C8.82802 0.737882 7.1817 1.41981 7.1817 2.78147C7.1817 3.18683 7.02068 3.57558 6.73404 3.86221L5.46787 5.12838C5.18124 5.41502 4.79248 5.57604 4.38712 5.57604C3.02546 5.57604 2.34353 7.22235 3.30638 8.18519L7.81479 12.6936C8.77763 13.6564 10.4239 12.9745 10.4239 11.6129C10.4239 11.2075 10.585 10.8187 10.8716 10.5321Z" 
        :stroke="strokeColor" 
        stroke-width="1.5" 
        stroke-linecap="round"
    />
</svg>

</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#f4f1ff',
        },
        strokeColor: {
            type: String,
            default:'#886AF8',
        },
        size: {
            type: String,
            default: "16",
        },
        hoverColor: {
            type: String,
            default: '#DCD3FF',
        },
    },
};
</script>

<style scoped>
.paper-pin-outline:hover path {
    fill: v-bind(hoverColor);
}
</style>